module.exports = __webpack_public_path__ + "static/media/iphone 11 banner6.4009e118.jpg";